module.exports = __webpack_public_path__ + "img/icon-microsoft-store.86829e58.svg";